import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'if_other_please_describe_18'

export const dataPointDefinition = {
  retracedId: 'if_other_please_describe_18',
  name: 'If other, please describe:',
  description: 'Please list other types of workers included in the grievances and their corresponding number.',
  meta: {
    slcpMeta: {
      key: 'wi-gri-31f',
      number: 'WI-GRI-23.1',
      dataType: 'string',
      masterType: 'Follow-up',
      multiSelectKey: '',
      optionList: '',
      versionImported: '1.7.0',
      verificationTypeReq: 'follow-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: '',
      nonCompliance: '',
      humanShowHide: '[2],wi-gri-30',
      machineShowHide: '[2],wi-gri-30',
      completionCondition: 'any',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wi-gri-31f', version: '1.7.0', provider: 'slcp'}],
  sortingId: 36780,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
